module.exports = __webpack_public_path__ + "components/PaperTile/profil-zaufany.jpg?2a675026";


//////////////////
// WEBPACK FOOTER
// ./components/PaperTile/profil-zaufany.jpg
// module id = 1110
// module chunks = 0